import { InjectionToken } from '@angular/core';

/**
 * Default dialog settings
 */
export const DEFAULT_DIALOG_CONFIG = {
  width: '500px',
  height: 'auto',
  backdropClass: 'cdk-overlay-dark-backdrop',
  hasBackdrop: true
};

/**
 * Token for injecting dialog default settings
 */
export const DIALOG_DEFAULT_CONFIG = new InjectionToken<typeof DEFAULT_DIALOG_CONFIG>('DIALOG_DEFAULT_CONFIG', {
  providedIn: 'root',
  factory: () => DEFAULT_DIALOG_CONFIG
});

/**
 * Configuration for dialog components
 */
export type DialogConfig<D = unknown> = {
  width?: string;
  height?: string;
  panelClass?: string | string[];
  data?: D;
  backdropClass?: string;
  hasBackdrop?: boolean;
};
